module.exports = __webpack_public_path__ + "components/country-flag/static/lu-3fee20a29c3ca1fee0fb6dc1f629a819.svg";